
import React from "react";
import { Badge } from "@/components/ui/badge";

interface EmailEventBadgeProps {
  event?: string;
}

const EmailEventBadge: React.FC<EmailEventBadgeProps> = ({ event }) => {
  if (event === "sent")
    return (
      <Badge className="bg-emerald-100 text-emerald-700 border-emerald-200 hover:bg-emerald-100">
        Εστάλη
      </Badge>
    );
  if (event === "open")
    return (
      <Badge className="bg-blue-100 text-blue-700 border-blue-200 hover:bg-blue-100">
        Άνοιγμα
      </Badge>
    );
  if (event === "click" || (event && event.startsWith("click-")))
    return (
      <Badge className="bg-violet-100 text-violet-700 border-violet-200 hover:bg-violet-100">
        Κλικ
      </Badge>
    );
  if (event === "bounce")
    return <Badge variant="destructive">Αναπήδηση</Badge>;
  return <Badge variant="outline">{event || "—"}</Badge>;
};

export default EmailEventBadge;
